/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * CartControllerV2Api - axios parameter creator
 */
export const CartControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete: (tenant_1, ...args_1) => __awaiter(this, [tenant_1, ...args_1], void 0, function* (tenant, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantDelete', 'tenant', tenant);
            const localVarPath = `/cart/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} hashedToken
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete: (tenant_1, hashedToken_1, Accept_Language_1, ...args_1) => __awaiter(this, [tenant_1, hashedToken_1, Accept_Language_1, ...args_1], void 0, function* (tenant, hashedToken, Accept_Language, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'tenant', tenant);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'hashedToken', hashedToken);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/entries/eRx/{hashedToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {Array<string>} request_body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost: (tenant_1, Accept_Language_1, request_body_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, request_body_1, ...args_1], void 0, function* (tenant, Accept_Language, request_body, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'request_body' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'request_body', request_body);
            const localVarPath = `/cart/v2/{tenant}/entries/eRx`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet: (tenant_1, Accept_Language_1, purgeMessages_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, purgeMessages_1, nowZipCode_1, ...args_1], void 0, function* (tenant, Accept_Language, purgeMessages, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides information about the cart data
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet: (tenant_1, Accept_Language_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, ...args_1], void 0, function* (tenant, Accept_Language, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantMetadataGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantMetadataGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/metadata`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CartControllerV2Api - functional programming interface
 */
export const CartControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CartControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantDelete(tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} hashedToken
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntriesERxHashedTokenDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {Array<string>} request_body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntriesERxPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Provides information about the cart data
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet(tenant, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantMetadataGet(tenant, Accept_Language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantMetadataGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * CartControllerV2Api - factory interface
 */
export const CartControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CartControllerV2ApiFp(configuration);
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {CartControllerV2ApiCartV2TenantDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete(requestParameters, options) {
            return localVarFp.cartV2TenantDelete(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantEntriesERxHashedTokenDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesERxHashedTokenDelete(requestParameters.tenant, requestParameters.hashedToken, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {CartControllerV2ApiCartV2TenantEntriesERxPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesERxPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.request_body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get new or existing cart for customer (including guests)
         * @param {CartControllerV2ApiCartV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet(requestParameters, options) {
            return localVarFp.cartV2TenantGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides information about the cart data
         * @param {CartControllerV2ApiCartV2TenantMetadataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet(requestParameters, options) {
            return localVarFp.cartV2TenantMetadataGet(requestParameters.tenant, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CartControllerV2Api - object-oriented interface
 */
export class CartControllerV2Api extends BaseAPI {
    /**
     * Endpoint to delete the existing cart, if it exists
     * @param {CartControllerV2ApiCartV2TenantDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantDelete(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantEntriesERxHashedTokenDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantEntriesERxHashedTokenDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesERxHashedTokenDelete(requestParameters.tenant, requestParameters.hashedToken, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create or update eRx entries providing eRx hashedTokens
     * @param {CartControllerV2ApiCartV2TenantEntriesERxPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantEntriesERxPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesERxPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get new or existing cart for customer (including guests)
     * @param {CartControllerV2ApiCartV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantGet(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides information about the cart data
     * @param {CartControllerV2ApiCartV2TenantMetadataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantMetadataGet(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantMetadataGet(requestParameters.tenant, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
}
